module.exports = __webpack_public_path__ + "img/Number=112.ccde6146.png";